/* ============================================================
   AAA_CDC_outil.js — v2
   Destination : assets/AAA_CDC_outil.js
   ------------------------------------------------------------
   Générateur de cahier des charges — ToutEn3D
   Aucune valeur de couleur, de police ou de texte ici : tout vient
   du schema de section, injecté via le bloc JSON [data-cdc-config].

   IMPORTANT — le brief de modélisation interne n'est PAS généré ici.
   Il est construit par le Worker à partir des réponses. Rien de ce
   qui est interne ne transite par le navigateur du client.

   Nouveautés v2 :
   - couleurs par pastilles (obligatoire) + référence libre facultative
   - effets de matière (filament) et textures de surface (plateau) séparés
   - quantité par compteur et raccourcis, valeur réelle dès le chargement
   - repère d'échelle : description, valeur numérique, unité
   - purge automatique des réponses devenues invisibles
   - section « points à compléter » avec impact de chaque manque
   - frais d'étude activables et prix lu depuis le produit Shopify
   ============================================================ */
(function () {
  "use strict";

  var ROOTS = document.querySelectorAll("[data-cdc-root]");
  for (var r = 0; r < ROOTS.length; r++) init(ROOTS[r]);

  function init(root) {
    var CFG = {};
    try { CFG = JSON.parse(root.querySelector("[data-cdc-config]").textContent); } catch (e) { return; }

    var S = { v_qte: "1" };  // réponses — la quantité vaut réellement 1 dès le départ
    var FILES = [];          // {name, size, status, data, type}
    var gate = null;
    var step = 0, maxSeen = 0;
    var REF = null;
    var T0 = Date.now();     // horodatage d'ouverture (filtre anti-robot)
    var SKEY = "aaa_cdc_" + (CFG.section_id || "x");
    var TTL = 7 * 24 * 3600 * 1000;
    var PAYANT = !!CFG.etude_active && !!CFG.etude_variant_id;

    /* ---------- Filtre d'entrée ---------- */
    var GATE = [
      { v: "idee",    i: "\u{1F4A1}", t: "J'ai une idée, pas encore de fichier",         d: "Vous décrivez le besoin, nous concevons la pièce." },
      { v: "objet",   i: "🔍", t: "J'ai un objet à copier, réparer ou améliorer", d: "Relevé de cotes, rétro-conception, adaptation." },
      { v: "plan",    i: "\u{1F4D0}", t: "J'ai un croquis, un plan 2D ou des cotes",     d: "Nous modélisons à partir de vos éléments." },
      { v: "fichier", i: "\u{1F9CA}", t: "J'ai déjà un fichier 3D prêt à imprimer",      d: "Vous voulez uniquement la fabrication." }

    ];


    
    /* ---------- Structure du cahier des charges ---------- */
    var SCHEMA = [
      { key: "projet", label: "Projet", icon: "🎯", title: "Le projet",
        hint: "La partie la plus importante : ce que la pièce doit accomplir, pas seulement à quoi elle ressemble.",
        fields: [
          { id: "p_nom", type: "text", req: true, l: "Nom du projet", ph: "Ex. Support mural pour casque audio" },
          { id: "p_objectif", type: "textarea", req: true, l: "À quoi doit servir cette pièce ?",
            h: "Décrivez son rôle et le problème qu'elle résout. Cette réponse conditionne toutes nos décisions techniques.",
            ph: "Ex. Fixer un casque sous mon bureau sans percer le plateau, pour libérer de la place." },
          { id: "p_contexte", type: "choice", req: true, l: "Dans quel cadre ?", opts: [
            { v: "perso", t: "Usage personnel" },
            { v: "pro_interne", t: "Usage professionnel interne", d: "Outillage, gabarit, agencement, poste de travail" },
            { v: "revente", t: "Produit destiné à la vente", d: "Commercialisé sous votre marque" },
            { v: "proto", t: "Prototype avant industrialisation" },
            { v: "rechange", t: "Pièce de rechange" }] },
          { id: "p_existant", type: "choice", req: true, l: "Où en est le besoin ?", cols: 2, opts: [
            { v: "rien", t: "Tout est à créer" },
            { v: "insuffisant", t: "Une solution existe mais ne convient pas" },
            { v: "casse", t: "Je remplace une pièce cassée" },
            { v: "copie", t: "Je reproduis une pièce existante" }] },
          { id: "p_existant_txt", type: "text", l: "Qu'est-ce qui ne convient pas ?", ph: "En une ligne",
            showIf: function () { return S.p_existant === "insuffisant"; } },
          { id: "p_assemblage", type: "choice", l: "Doit-elle s'assembler avec quelque chose ?", cols: 2, opts: [
            { v: "non", t: "Non, elle est autonome" }, { v: "oui", t: "Oui, sur un objet existant" }] },
          { id: "p_assemblage_txt", type: "text", l: "Avec quoi ?", ph: "Marque, modèle, référence — ex. profilé alu 30×30",
            showIf: function () { return S.p_assemblage === "oui"; } }
        ] },

      { key: "contraintes", label: "Contraintes", icon: "📏", title: "Contraintes techniques",
        hint: "Nous choisissons le matériau à votre place : décrivez l'usage réel, pas la solution technique.",
        fields: [
          { id: "c_dims", type: "dims", l: "Encombrement maximal (mm)", h: "Une estimation suffit.",
            inline: { id: "c_dims_nc", t: "Je ne connais pas encore les dimensions" } },
          { id: "c_sollicit", type: "choice", req: true, l: "Comment sera-t-elle sollicitée ?", opts: [
            { v: "deco", t: "Décorative", d: "Peu ou pas manipulée" },
            { v: "manip", t: "Manipulée régulièrement" },
            { v: "effort", t: "Soumise à un effort mécanique", d: "Serrage, flexion, traction" },
            { v: "charge", t: "Porteuse d'une charge", d: "Elle supporte le poids d'un objet" },
            { v: "mouvement", t: "En mouvement ou en frottement", d: "Rotation, glissement, usure" }] },
          { id: "c_charge", type: "number", l: "Charge estimée (kg)",
            showIf: function () { return S.c_sollicit === "charge" || S.c_sollicit === "effort"; } },
          { id: "c_milieu", type: "multi", l: "Environnement d'utilisation", cols: 2, opts: [
            { v: "interieur", t: "Intérieur" },
            { v: "exterieur", t: "Extérieur", d: "Soleil, pluie, gel" },
            { v: "chaud", t: "Chaleur > 50 °C", d: "Véhicule, moteur, cuisine" },
            { v: "alim", t: "Contact alimentaire" },
            { v: "chimique", t: "Huiles, produits chimiques" },
            { v: "eau", t: "Contact prolongé avec l'eau" },
            { v: "peau", t: "Contact prolongé avec la peau" }] },
          { id: "c_tolerance", type: "choice", l: "Des cotes critiques à respecter ?",
            h: "Perçage, emmanchement, filetage, jeu de montage.", cols: 2,
            opts: [{ v: "non", t: "Non" }, { v: "oui", t: "Oui" }] },
          { id: "c_tolerance_txt", type: "text", l: "Lesquelles ?", ph: "Ex. alésage Ø8 H7, entraxe 45 mm ±0,2",
            showIf: function () { return S.c_tolerance === "oui"; } }
        ] },

      { key: "integrations", label: "Intégrations", icon: "🧩", title: "Composants à intégrer",
        hint: "Ces éléments changent la conception en profondeur : logements, tolérances, accessibilité au montage.",
        fields: [
          { id: "i_comp", type: "multi", l: "Des éléments non imprimés doivent-ils être intégrés ?", cols: 2, opts: [
            { v: "aucun", t: "Aucun, pièce 100 % imprimée" },
            { v: "aimants", t: "Aimants" },
            { v: "inserts", t: "Inserts filetés, visserie" },
            { v: "led", t: "Éclairage LED" },
            { v: "elec", t: "Électronique", d: "Carte, capteur, batterie" },
            { v: "meca", t: "Roulements, axes, guidages" },
            { v: "mobile", t: "Parties mobiles", d: "Charnière, clip, coulisse" },
            { v: "materiaux", t: "Autres matériaux", d: "Bois, métal, tissu" }] },
          { id: "i_aimants_txt", type: "text", l: "Aimants : dimensions ou force",
            ph: "Ex. Ø10×3 mm néodyme, ou « doit tenir 500 g »",
            showIf: function () { return has("i_comp", "aimants"); } },
          { id: "i_led_alim", type: "choice", l: "Alimentation de l'éclairage", cols: 2, opts: [
            { v: "secteur", t: "Secteur 230 V" }, { v: "usb", t: "USB" },
            { v: "piles", t: "Piles" }, { v: "adef", t: "À définir" }],
            showIf: function () { return has("i_comp", "led"); } },
          { id: "i_elec_txt", type: "textarea", l: "Électronique : décrivez les composants",
            ph: "Ex. ESP32 + capteur de température + module USB-C",
            showIf: function () { return has("i_comp", "elec"); } },
          { id: "i_mat_txt", type: "text", l: "Quels autres matériaux ?", ph: "Ex. plateau chêne 18 mm, tige acier Ø6",
            showIf: function () { return has("i_comp", "materiaux"); } },
          { id: "i_fourniture", type: "choice", l: "Qui fournit ces composants ?", opts: [
            { v: "client", t: "Je les fournis" },
            { v: "t3d", t: "ToutEn3D les source et les intègre" },
            { v: "adef", t: "À définir ensemble" }],
            showIf: function () { return S.i_comp && S.i_comp.length && !has("i_comp", "aucun"); } },
          { id: "i_assemblage", type: "choice", l: "Structure attendue", cols: 2, opts: [
            { v: "monobloc", t: "Pièce unique monobloc" },
            { v: "demontable", t: "Assemblage démontable" },
            { v: "definitif", t: "Assemblage définitif" },
            { v: "adef", t: "À définir" }] }
        ] },

      { key: "finitions", label: "Finitions", icon: "🎨", title: "Aspect et finitions",
        hint: "Le niveau de finition est le principal levier de prix après la conception.",
        fields: [
          { id: "f_exigence", type: "choice", req: true, l: "Niveau d'exigence visuel", opts: [
            { v: "fonctionnel", t: "Fonctionnel", d: "L'aspect est secondaire" },
            { v: "soigne", t: "Soigné", d: "Pièce visible au quotidien" },
            { v: "presentation", t: "Qualité présentation", d: "Client final, vitrine, salon, photo produit" }] },
          { id: "f_couleur", type: "swatch", req: true, l: "Couleur souhaitée",
            h: "Sélectionnez une ou plusieurs teintes. Nous confirmerons la disponibilité exacte dans la proposition.",
            opts: [
            { v: "noir", t: "Noir", c: "#1A1A1A" }, { v: "blanc", t: "Blanc", c: "#F3F3EE" },
            { v: "gris", t: "Gris", c: "#8A8F98" }, { v: "argent", t: "Argent", c: "#C4C9CF" },
            { v: "rouge", t: "Rouge", c: "#C0392B" }, { v: "bordeaux", t: "Bordeaux", c: "#6E1E28" },
            { v: "orange", t: "Orange", c: "#E1701A" }, { v: "jaune", t: "Jaune", c: "#E9C213" },
            { v: "vert", t: "Vert", c: "#2E8B57" }, { v: "vert_fonce", t: "Vert foncé", c: "#1F4D3A" },
            { v: "bleu", t: "Bleu", c: "#1F6FEB" }, { v: "bleu_nuit", t: "Bleu nuit", c: "#152A4A" },
            { v: "violet", t: "Violet", c: "#6B4BA3" }, { v: "rose", t: "Rose", c: "#D96BA0" },
            { v: "marron", t: "Marron", c: "#6B4A2F" }, { v: "beige", t: "Beige", c: "#D9C7A7" },
            { v: "or", t: "Or", c: "#C9A227" }, { v: "cuivre", t: "Cuivre", c: "#B06A3B" },
            { v: "transparent", t: "Transparent", c: "transp" }, { v: "conseil", t: "À définir", c: "multi" }] },
          { id: "f_couleur_txt", type: "text", l: "Référence précise (facultatif)",
            ph: "RAL 7016, #2B2B2B, Pantone, ou « assorti à l'échantillon joint »" },
          { id: "f_effet", type: "multi", l: "Recherchez-vous un effet de matière ?",
            h: "Ces effets viennent du filament : ils concernent toute la pièce et modifient ses propriétés mécaniques. Nous vous indiquerons les compromis.",
            cols: 2, opts: [
            { v: "aucun", t: "Aucun, couleur unie" },
            { v: "carbone", t: "Fibre de carbone", d: "Filament chargé — mat, technique, plus rigide" },
            { v: "metal", t: "Effet métal" }, { v: "bois", t: "Effet bois" },
            { v: "cuir", t: "Aspect cuir ou texturé" }, { v: "phospho", t: "Phosphorescent" },
            { v: "translucide", t: "Translucide ou diffusant" },
            { v: "bicolore", t: "Bicolore selon l'angle", d: "La teinte change avec l'orientation de la pièce" },
            { v: "soie", t: "Effet soie ou nacré" },
            { v: "conseil", t: "Je souhaite votre recommandation" }] },
          { id: "f_texture", type: "multi", l: "Souhaitez-vous une texture de surface ?",
            h: "Ces motifs sont obtenus par transfert depuis le plateau d'impression : ils n'apparaissent que sur la face en contact avec le plateau, jamais sur toute la pièce.",
            cols: 2, opts: [
            { v: "aucune", t: "Aucune" },
            { v: "diamond", t: "Diamond", d: "Facettes régulières" },
            { v: "starry", t: "Starry", d: "Micro-éclats scintillants" },
            { v: "galaxy", t: "Galaxy", d: "Grain profond irrégulier" },
            { v: "carbon", t: "Carbon Fiber", d: "Trame tissée" },
            { v: "conseil", t: "Je souhaite votre recommandation" }] },
          { id: "f_fin", type: "multi", l: "Finitions envisagées", cols: 2, opts: [
            { v: "brut", t: "Brut d'impression" }, { v: "lissage", t: "Lissage et ponçage" },
            { v: "peinture", t: "Peinture" }, { v: "vernis", t: "Vernis de protection" },
            { v: "marquage", t: "Gravure ou marquage" }, { v: "perso", t: "Logo ou texte personnalisé" },
            { v: "conseil", t: "Je souhaite votre recommandation" }] },
          { id: "f_perso_txt", type: "text", l: "Texte ou logo à intégrer", ph: "Texte exact, ou « logo fourni en vectoriel »",
            showIf: function () { return has("f_fin", "perso") || has("f_fin", "marquage"); } },
          { id: "f_faces", type: "choice", l: "Quelles faces seront visibles ?",
            h: "Cela détermine l'orientation d'impression, l'emplacement des supports et la face qui pourra porter une texture.",
            cols: 2, opts: [
            { v: "toutes", t: "Toutes" }, { v: "une", t: "Une face principale" },
            { v: "cachee", t: "Pièce cachée une fois montée" }] }
        ] },

      { key: "cadre", label: "Cadre", icon: "📦", title: "Volumes, délais et cadre", hint: "",
        fields: [
          { id: "v_qte", type: "qty", req: true, l: "Quantité pour cette demande",
            h: "Utilisez les raccourcis ou saisissez le nombre exact." },
          { id: "v_recurrence", type: "choice", l: "Ce besoin est", cols: 2, opts: [
            { v: "unique", t: "Ponctuel, pièce unique" }, { v: "repete", t: "Ponctuel mais répété" },
            { v: "serie", t: "Une série régulière" }, { v: "inconnu", t: "Encore incertain" }] },
          { id: "v_volume", type: "choice", l: "Volume annuel estimé", cols: 2, opts: [
            { v: "50", t: "Moins de 50 pièces" }, { v: "500", t: "50 à 500 pièces" },
            { v: "2000", t: "500 à 2 000 pièces" }, { v: "plus", t: "Plus de 2 000 pièces" }],
            showIf: function () { return S.v_recurrence === "serie"; } },
          { id: "d_date", type: "date", l: "Date de besoin", h: "Laissez vide si aucune échéance." },
          { id: "d_flex", type: "choice", l: "Cette échéance est", cols: 2, opts: [
            { v: "imperative", t: "Impérative", d: "Salon, événement, arrêt de production" },
            { v: "marge", t: "Souhaitée, une semaine de marge" },
            { v: "flexible", t: "Indicative" }, { v: "aucune", t: "Aucune contrainte" }] },
          { id: "b_budget", type: "choice", req: true, l: "Budget envisagé",
            h: "Une fourchette suffit : elle nous permet de calibrer la proposition plutôt que de vous envoyer un devis hors sujet.",
            cols: 2, opts: [
            { v: "-50", t: "Moins de 50 €" }, { v: "50-150", t: "50 à 150 €" },
            { v: "150-400", t: "150 à 400 €" }, { v: "400-1000", t: "400 à 1 000 €" },
            { v: "1000+", t: "Plus de 1 000 €" },
            { v: "cadrer", t: "À cadrer ensemble", d: "Proposition en trois niveaux" }] },
          { id: "l_livrable", type: "multi", req: true, l: "Que devons-nous vous livrer ?", cols: 2, opts: [
            { v: "piece", t: "La ou les pièces fabriquées" }, { v: "fichier", t: "Le fichier 3D" },
            { v: "plan", t: "Les plans 2D cotés" }, { v: "notice", t: "Une notice de montage" }] },
          { id: "l_remise", type: "choice", req: true, l: "Comment souhaitez-vous récupérer votre pièce ?", cols: 2, opts: [
            { v: "livraison", t: "Livraison à mon adresse" },
            { v: "main_propre", t: "Remise en main propre", d: "À Plaisir (78370), sur rendez-vous" },
            { v: "adef", t: "À définir plus tard" }],
            showIf: function () { return has("l_livrable", "piece"); } },
          { id: "l_usage", type: "choice", req: true, l: "Usage prévu des livrables numériques",
            h: "Fichier 3D, plans cotés et notice de montage sont des créations : leur usage conditionne la licence et le prix.",
            opts: [
            { v: "perso", t: "Usage personnel", d: "Pour vos propres besoins, sans diffusion" },
            { v: "commercial", t: "Usage commercial", d: "Production, revente ou diffusion — cession de droits à chiffrer" }],
            showIf: function () { return has("l_livrable", "fichier") || has("l_livrable", "plan") || has("l_livrable", "notice"); } },
          { id: "l_confid", type: "choice", l: "Le projet est-il confidentiel ?", cols: 2, opts: [
            { v: "non", t: "Non" }, { v: "oui", t: "Oui, accord de confidentialité nécessaire" }] }
        ] },

      { key: "contact", label: "Contact", icon: "✉️", title: "Vos coordonnées et documents", hint: "",
        fields: [
          { id: "ct_type", type: "choice", req: true, l: "Vous êtes", cols: 2, opts: [
            { v: "particulier", t: "Un particulier" }, { v: "pro", t: "Un professionnel" }] },
          { id: "ct_societe", type: "text", req: true, l: "Raison sociale",
            showIf: function () { return S.ct_type === "pro"; } },
          { id: "ct_siret", type: "text", l: "SIREN ou SIRET", ph: "123 456 789 00012",
            h: "Nécessaire pour la facturation entre professionnels.",
            showIf: function () { return S.ct_type === "pro"; } },
          { id: "ct_docs", type: "multi", l: "Documents attendus avec la livraison", cols: 2, opts: [
            { v: "aucun", t: "Aucun besoin particulier" }, { v: "fiche", t: "Fiche technique matière" },
            { v: "plan", t: "Plan coté validé avant fabrication" }, { v: "conformite", t: "Attestation de conformité" }],
            showIf: function () { return S.ct_type === "pro"; } },
          { id: "ct_commande", type: "choice", l: "Mode de commande", cols: 2, opts: [
            { v: "bdc", t: "Bon de commande" }, { v: "devis", t: "Devis signé" }, { v: "direct", t: "Paiement direct" }],
            showIf: function () { return S.ct_type === "pro"; } },
          { id: "ct_identite", type: "duo", req: true, l: "Prénom et nom",
            a: { id: "ct_prenom", ph: "Prénom" }, b: { id: "ct_nom", ph: "Nom" } },
          { id: "ct_email", type: "email", req: true, l: "Email",
            h: "Votre cahier des charges y sera envoyé au format PDF." },
          { id: "ct_tel", type: "tel", l: "Téléphone" },
          { id: "ct_adresse", type: "address", req: true, l: "Adresse postale",
            h: "Nécessaire pour établir le devis et la facture. Commencez à saisir : les suggestions complètent le code postal et la ville." },
          { id: "ct_complement", type: "text", l: "Complément d'adresse", ph: "Bâtiment, étage, digicode, lieu-dit" },
          { id: "ct_cpville", type: "duo", req: true, l: "Code postal et ville",
            a: { id: "ct_cp", ph: "Code postal", w: "140px" }, b: { id: "ct_ville", ph: "Ville" } },
          { id: "ct_files", type: "files", l: "Photos, croquis, plans, fichiers 3D",
            h: "Ils seront annexés à votre cahier des charges. JPG, PNG, PDF, STL, STEP — 25 Mo au total." },
          { id: "ct_vues", type: "multi", l: "Quelles vues avez-vous fournies ?", cols: 2, opts: [
            { v: "face", t: "De face" }, { v: "dessus", t: "De dessus" }, { v: "cote", t: "De côté" },
            { v: "situation", t: "En situation", d: "L'objet à sa place d'utilisation" },
            { v: "croquis", t: "Un croquis coté" }, { v: "plan", t: "Un plan technique" }],
            showIf: function () { return FILES.length > 0; } },
          { id: "ct_echelle", type: "mesure", l: "Repère d'échelle",
            h: "Indiquez une dimension que vous avez mesurée sur l'objet photographié. Sans elle, une photo ne donne aucune information de taille exploitable.",
            a: { id: "ct_ech_quoi", ph: "Quelle dimension avez-vous mesurée ? Ex. largeur du socle" },
            b: { id: "ct_ech_val", ph: "0" },
            u: { id: "ct_ech_unite", opts: ["mm", "cm", "m", "pouces"] },
            showIf: function () { return FILES.length > 0; } },
          { id: "ct_lien", type: "text", l: "Ou un lien de partage", ph: "WeTransfer, Google Drive, Dropbox…" }
        ] }
    ];

    /* Ce qui manque, et ce que cela change concrètement pour le projet.
       Seuls les champs listés ici remontent dans « points à compléter ». */
    var IMPACT = {
      c_dims: "Le chiffrage restera une fourchette large tant que l'encombrement n'est pas cadré.",
      c_milieu: "Le choix du matériau ne pourra pas être arrêté sans connaître l'environnement d'usage.",
      c_charge: "Sans charge estimée, le dimensionnement sera prudent, donc plus lourd et plus cher.",
      c_tolerance: "La pièce sera traitée sans cote critique : aucun ajustement précis ne sera garanti.",
      c_tolerance_txt: "Aucune tolérance ne pourra être garantie tant que les cotes critiques ne sont pas précisées.",
      p_assemblage_txt: "L'interface devra être relevée sur place ou sur échantillon, ce qui allonge le délai.",
      i_aimants_txt: "Le logement d'aimant ne peut pas être coté sans ses dimensions.",
      i_elec_txt: "Les logements et passages de câbles ne peuvent pas être prévus sans le détail des composants.",
      i_mat_txt: "L'assemblage avec les autres matériaux ne peut pas être conçu sans leurs caractéristiques.",
      i_fourniture: "Sans savoir qui fournit les composants, le délai et le prix comportent une part d'incertitude.",
      i_assemblage: "Nous retiendrons par défaut la structure la plus simple à fabriquer.",
      f_couleur_txt: "La teinte sera choisie dans notre stock, au plus proche de la couleur sélectionnée.",
      f_faces: "L'orientation d'impression sera choisie par défaut, et une texture ne pourra pas être positionnée.",
      f_fin: "Le niveau de finition sera déduit de votre exigence visuelle, sans validation de votre part.",
      v_recurrence: "Sans visibilité sur la récurrence, la fabrication ne sera pas optimisée pour la série.",
      v_volume: "Le prix unitaire d'une série ne peut pas être calculé sans volume annuel.",
      d_date: "Votre projet sera planifié au fil de l'eau, sans priorité particulière.",
      d_flex: "L'échéance sera traitée comme indicative.",
      l_confid: "Le projet sera traité sans engagement de confidentialité particulier.",
      ct_tel: "Les échanges se feront uniquement par email : comptez davantage d'allers-retours.",
      ct_complement: "Une livraison peut échouer si l'accès nécessite un digicode ou un étage.",
      ct_files: "La compréhension du besoin reposera uniquement sur votre description écrite.",
      ct_vues: "Sans savoir quelles vues sont fournies, l'interprétation des images sera plus incertaine.",
      ct_echelle: "Sans repère d'échelle, vos photos ne permettent de déduire aucune dimension réelle.",
      ct_docs: "Aucun document technique ne sera fourni avec la livraison.",
      ct_commande: "Le mode de commande sera à caler avant la facturation."
    };

    /* ---------- Utilitaires ---------- */
    function q(sel) { return root.querySelector(sel); }
    function each(sel, fn) { var n = root.querySelectorAll(sel); for (var i = 0; i < n.length; i++) fn(n[i]); }
    function has(id, v) { return Array.isArray(S[id]) && S[id].indexOf(v) > -1; }
    function esc(s) { return String(s == null ? "" : s).replace(/[&<>"]/g, function (c) {
      return { "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;" }[c]; }); }
    function visible(f) { return !f.showIf || f.showIf(); }
    function labelOf(f, v) { if (!f.opts) return v;
      for (var i = 0; i < f.opts.length; i++) if (f.opts[i].v === v) return f.opts[i].t; return v; }
    function filled(id) { return S[id] !== undefined && S[id] !== null && String(S[id]).trim() !== ""; }
    function answered(f) {
      if (f.type === "files") return FILES.length > 0;
      if (f.type === "duo" || f.type === "mesure") return filled(f.a.id) && filled(f.b.id);
      var v = S[f.id]; if (Array.isArray(v)) return v.length > 0;
      return v !== undefined && v !== null && String(v).trim() !== "";
    }
    function stepValid(i) {
      var ok = true;
      SCHEMA[i].fields.forEach(function (f) { if (f.req && visible(f) && !answered(f)) ok = false; });
      if (i === SCHEMA.length - 1 && !validEmail(S.ct_email)) ok = false;
      return ok;
    }
    function validEmail(v) { return /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(String(v || "")); }
    function progress() {
      var t = 0, d = 0;
      SCHEMA.forEach(function (st) { st.fields.forEach(function (f) {
        if (!visible(f)) return; t++; if (answered(f)) d++; }); });
      return t ? Math.round(d / t * 100) : 0;
    }
    function find(id) {
      for (var i = 0; i < SCHEMA.length; i++)
        for (var j = 0; j < SCHEMA[i].fields.length; j++)
          if (SCHEMA[i].fields[j].id === id) return SCHEMA[i].fields[j];
      return {};
    }
    function manquants() {
      var out = [];
      SCHEMA.forEach(function (st, i) { st.fields.forEach(function (f) {
        if (!visible(f) || answered(f) || !IMPACT[f.id]) return;
        out.push({ l: f.l, i: IMPACT[f.id], s: i });
      }); });
      return out;
    }

    /* Toute réponse dont le champ n'est plus affiché est effacée : elle ne doit
       apparaître ni dans le récapitulatif, ni dans le PDF, ni dans le brief.
       Corrige le cas du client qui saisit un SIRET puis bascule en particulier. */
    function visibleKeys() {
      var k = {};
      SCHEMA.forEach(function (st) { st.fields.forEach(function (f) {
        if (!visible(f)) return;
        if (f.type === "duo" || f.type === "mesure") {
          k[f.a.id] = 1; k[f.b.id] = 1; if (f.u) k[f.u.id] = 1;
        } else k[f.id] = 1;
        if (f.inline) k[f.inline.id] = 1;
      }); });
      return k;
    }
    function purge() {
      var k = visibleKeys();
      Object.keys(S).forEach(function (id) { if (!k[id]) delete S[id]; });
    }

    /* Indice de complexité — sert au tri des demandes côté atelier */
    function complexity() {
      var n = 0;
      if (S.i_comp) n += S.i_comp.filter(function (v) { return v !== "aucun"; }).length;
      if (S.c_tolerance === "oui") n += 2;
      if (S.c_sollicit === "charge" || S.c_sollicit === "mouvement") n += 2;
      if (has("c_milieu", "exterieur") || has("c_milieu", "chaud") ||
          has("c_milieu", "chimique") || has("c_milieu", "alim")) n += 1;
      if (S.f_exigence === "presentation") n += 2;
      if (S.f_effet) n += S.f_effet.filter(function (v) { return v !== "aucun" && v !== "conseil"; }).length;
      if (S.f_texture) n += S.f_texture.filter(function (v) { return v !== "aucune" && v !== "conseil"; }).length;
      if (S.v_recurrence === "serie") n += 2;
      if (S.l_usage === "commercial") n += 1;
      if (S.l_confid === "oui") n += 1;
      if (n <= 3) return { t: "Simple", c: "pill--3", n: n };
      if (n <= 8) return { t: "Intermédiaire", c: "", n: n };
      return { t: "Complexe", c: "pill--2", n: n };
    }

    /* ---------- Sauvegarde locale ---------- */
    function save() {
      try { localStorage.setItem(SKEY, JSON.stringify({ t: Date.now(), gate: gate, step: step, S: S })); }
      catch (e) {}
    }
    function loadSaved() {
      try {
        var raw = localStorage.getItem(SKEY); if (!raw) return null;
        var d = JSON.parse(raw);
        if (!d || !d.t || Date.now() - d.t > TTL) { localStorage.removeItem(SKEY); return null; }
        return d;
      } catch (e) { return null; }
    }
    function clearSaved() { try { localStorage.removeItem(SKEY); } catch (e) {} }

    /* ---------- Rendu des champs ---------- */
    function fieldHTML(f) {
      var v = S[f.id], h = '<div class="fld" data-f="' + f.id + '">';
      h += '<label class="fld__l">' + esc(f.l) + (f.req ? ' <span class="req">*</span>' : "") + "</label>";
      if (f.h) h += '<p class="fld__h">' + esc(f.h) + "</p>";

      if (f.type === "choice" || f.type === "multi") {
        h += '<div class="opts' + (f.cols === 2 ? " opts--2" : "") + '">';
        f.opts.forEach(function (o) {
          var on = f.type === "multi" ? has(f.id, o.v) : v === o.v;
          h += '<label class="opt' + (on ? " is-on" : "") + '"><input type="' +
               (f.type === "multi" ? "checkbox" : "radio") + '" name="' + f.id + '" value="' + o.v + '"' +
               (on ? " checked" : "") + '><span><span class="opt__t">' + esc(o.t) + "</span>" +
               (o.d ? '<span class="opt__d">' + esc(o.d) + "</span>" : "") + "</span></label>";
        });
        h += "</div>";

      } else if (f.type === "swatch") {
        h += '<div class="swatches">' + f.opts.map(function (o) {
          var on = has(f.id, o.v);
          var st = o.c === "transp" ? ' class="transp"'
                 : (o.c === "multi" ? ' class="multi"' : ' style="background:' + o.c + '"');
          return '<button type="button" class="sw' + (on ? " is-on" : "") +
                 '" data-sw="' + f.id + '" data-v="' + o.v + '" aria-pressed="' + on + '">' +
                 "<i" + st + "></i><span>" + esc(o.t) + "</span></button>";
        }).join("") + "</div>";

      } else if (f.type === "qty") {
        var qv = parseInt(S[f.id], 10) || 1;
        h += '<div class="qty"><div class="qty__box">' +
             '<button type="button" data-qstep="-1" aria-label="Diminuer">&minus;</button>' +
             '<input type="number" min="1" step="1" name="' + f.id + '" value="' + qv + '">' +
             '<button type="button" data-qstep="1" aria-label="Augmenter">+</button></div>' +
             '<div class="qty__chips">' + [1, 2, 5, 10, 25, 50, 100].map(function (n) {
               return '<button type="button" data-qset="' + n + '"' + (qv === n ? ' class="is-on"' : "") + ">" + n + "</button>";
             }).join("") + "</div></div>";

      } else if (f.type === "mesure") {
        h += '<div class="mesure">' +
             '<input type="text" name="' + f.a.id + '" value="' + esc(S[f.a.id] || "") + '" placeholder="' + esc(f.a.ph) + '">' +
             '<input type="number" min="0" step="any" name="' + f.b.id + '" value="' + esc(S[f.b.id] || "") + '" placeholder="' + esc(f.b.ph) + '">' +
             '<select name="' + f.u.id + '">' + f.u.opts.map(function (u) {
               return '<option value="' + u + '"' + ((S[f.u.id] || "mm") === u ? " selected" : "") + ">" + u + "</option>";
             }).join("") + "</select></div>";

      } else if (f.type === "duo") {
        h += '<div class="' + (f.a.w || f.b.w ? "three" : "two") + '">' +
             '<input type="text" name="' + f.a.id + '" value="' + esc(S[f.a.id] || "") + '" placeholder="' + esc(f.a.ph) + '">' +
             '<input type="text" name="' + f.b.id + '" value="' + esc(S[f.b.id] || "") + '" placeholder="' + esc(f.b.ph) + '"></div>';

      } else if (f.type === "dims") {
        var d = v || {}, dis = S.c_dims_nc ? " disabled" : "";
        h += '<div class="dims">' + ["x", "y", "z"].map(function (k, i) {
          return "<div><label>" + ["Longueur", "Largeur", "Hauteur"][i] + "</label>" +
                 '<input type="number" min="0" data-dim="' + k + '" name="' + f.id + '" value="' +
                 esc(d[k] || "") + '" placeholder="0"' + dis + "></div>";
        }).join("") + "</div>";

      } else if (f.type === "address") {
        h += '<input type="text" data-addr name="' + f.id + '" value="' + esc(v || "") +
             '" placeholder="Numéro et nom de voie" autocomplete="off"><div data-addr-sugg></div>';

      } else if (f.type === "files") {
        h += '<div class="drop" data-drop><b>Déposez vos fichiers ici</b><span>ou cliquez pour parcourir</span></div>' +
             '<input type="file" data-file multiple hidden accept=".jpg,.jpeg,.png,.webp,.heic,.pdf,.stl,.step,.stp,.3mf,.obj">' +
             (FILES.length ? '<ul class="files">' + FILES.map(function (o, i) {
               return '<li class="' + (o.status === "ko" ? "is-ko" : "") + '"><span>' + esc(o.name) +
                      '</span><span class="st">' + esc(statusLabel(o)) + "</span>" +
                      '<button type="button" data-rm="' + i + '">Retirer</button></li>';
             }).join("") + "</ul>" : "");

      } else if (f.type === "textarea") {
        h += '<textarea name="' + f.id + '" placeholder="' + esc(f.ph || "") + '">' + esc(v || "") + "</textarea>";

      } else {
        h += '<input type="' + f.type + '" name="' + f.id + '" value="' + esc(v || "") +
             '" placeholder="' + esc(f.ph || "") + '">';
      }

      if (f.inline) h += '<label class="inline"><input type="checkbox" data-inline="' + f.inline.id + '"' +
                         (S[f.inline.id] ? " checked" : "") + "><span>" + esc(f.inline.t) + "</span></label>";
      return h + "</div>";
    }
    function statusLabel(o) {
      if (o.status === "up") return "Préparation…";
      if (o.status === "ok") return "Prêt";
      if (o.status === "ko") return "Échec — retirez ou réessayez";
      return "";
    }

    /* ---------- Écrans ---------- */
    function renderGate() {
      q("[data-cdc-steps]").hidden = true;
      var saved = loadSaved();
      var resume = saved ? '<div class="resume"><span>Une demande en cours a été retrouvée sur cet appareil.</span>' +
        '<span class="resume__a"><button type="button" class="btn btn--p" data-resume>Reprendre</button>' +
        '<button type="button" class="btn btn--s" data-fresh>Recommencer</button></span></div>' : "";
      q("[data-cdc-app]").innerHTML =
        '<div class="gate">' + resume + '<div class="cdc__panel">' +
        '<h2 class="gate__q">' + esc(CFG.gate_title) + "</h2>" +
        '<p class="gate__s">' + esc(CFG.gate_sub) + '</p><div class="gate__opts">' +
        GATE.map(function (g) {
          return '<button type="button" class="gate__opt" data-gate="' + g.v + '">' +
                 '<span class="gate__opt-i">' + g.i + "</span><span>" +
                 '<span class="gate__opt-t">' + g.t + '</span><p class="gate__opt-d">' + g.d + "</p></span></button>";
        }).join("") + "</div></div></div>";

      each("[data-gate]", function (b) {
        b.onclick = function () {
          gate = b.getAttribute("data-gate");
          if (gate === "fichier") renderRedirect(); else { step = 0; save(); render(); }
          top();
        };
      });
      var rb = q("[data-resume]"), fb = q("[data-fresh]");
      if (rb) rb.onclick = function () {
        var d = loadSaved(); if (!d) return;
        S = d.S || { v_qte: "1" }; gate = d.gate; step = d.step || 0; maxSeen = step; render(); top();
      };
      if (fb) fb.onclick = function () { clearSaved(); renderGate(); };
    }

    function renderRedirect() {
      q("[data-cdc-app]").innerHTML =
        '<div class="gate"><div class="redirect"><h3>Votre besoin relève du devis d\'impression</h3>' +
        "<p>Vous disposez d'un fichier 3D exploitable : notre configurateur vous donne une estimation immédiate " +
        "et un devis ferme sous 48 h, sans cahier des charges" + (PAYANT ? " ni frais d'étude" : "") + ".</p>" +
        '<a class="btn btn--p" href="' + esc(CFG.url_devis) + '">Obtenir mon devis d\'impression</a>' +
        '<div class="note" style="text-align:left;margin-top:26px"><span>ℹ️</span><span>' +
        "<b>Votre fichier doit être modifié, adapté ou complété&nbsp;?</b><br>Ajout de fonctions, correction de géométrie, " +
        'intégration de composants, mise en tolérance : <a href="#" data-stay>poursuivez le cahier des charges</a>.' +
        '</span></div><div style="margin-top:18px"><button type="button" class="btn btn--s" data-back>Revenir en arrière</button></div>' +
        "</div></div>";
      q("[data-stay]").onclick = function (e) { e.preventDefault(); gate = "fichier_modif"; step = 0; save(); render(); };
      q("[data-back]").onclick = function () { gate = null; renderGate(); };
    }

    function renderSteps() {
      var el = q("[data-cdc-steps]"); el.hidden = false;
      el.innerHTML = SCHEMA.map(function (st, i) {
        var cls = i === step ? "is-active" : (i < maxSeen ? "is-done" : "");
        return '<button type="button" class="cdc__step ' + cls + '" data-step="' + i + '"' +
               (i > maxSeen ? " disabled" : "") + '><span class="cdc__step-n">' + (i + 1) +
               '</span><span class="cdc__step-l">' + st.label + "</span></button>";
      }).join("");
      each("[data-step]", function (b) {
        b.onclick = function () { step = +b.getAttribute("data-step"); render(); top(); };
      });
    }

    function asideHTML() {
      var p = progress(), cx = complexity();
      var dims = S.c_dims_nc ? "À définir"
        : (S.c_dims && (S.c_dims.x || S.c_dims.y || S.c_dims.z)
          ? (S.c_dims.x || "?") + " × " + (S.c_dims.y || "?") + " × " + (S.c_dims.z || "?") + " mm" : null);
      var comps = has("i_comp", "aucun") ? "Aucun"
        : (S.i_comp && S.i_comp.length ? S.i_comp.length + " élément" + (S.i_comp.length > 1 ? "s" : "") : null);
      var ne = (S.f_effet || []).filter(function (v) { return v !== "aucun"; }).length +
               (S.f_texture || []).filter(function (v) { return v !== "aucune"; }).length;
      var col = (S.f_couleur || []).length
        ? (S.f_couleur.length > 1 ? S.f_couleur.length + " teintes" : labelOf(find("f_couleur"), S.f_couleur[0]))
        : null;
      var rows = [
        ["Projet", S.p_nom],
        ["Cadre", S.p_contexte ? labelOf(find("p_contexte"), S.p_contexte) : null],
        ["Sollicitation", S.c_sollicit ? labelOf(find("c_sollicit"), S.c_sollicit) : null],
        ["Encombrement", dims], ["Intégrations", comps],
        ["Finition", S.f_exigence ? labelOf(find("f_exigence"), S.f_exigence) : null],
        ["Couleur", col], ["Effets", ne ? ne + " effet" + (ne > 1 ? "s" : "") : null],
        ["Quantité", S.v_qte], ["Échéance", S.d_date]
      ];
      return '<div class="cdc__aside"><div class="aside__tag">📄 Cahier des charges</div>' +
        '<div class="aside__lbl">Complétude du document</div>' +
        '<div class="aside__pct">' + p + "<small>&thinsp;%</small></div>" +
        '<div class="bar"><span style="width:' + p + '%"></span></div>' +
        '<p class="aside__cap">Toutes les questions ne s\'appliquent pas à tous les projets.</p>' +
        '<div class="aside__lbl">Complexité estimée</div><span class="pill ' + cx.c + '">' + cx.t + "</span>" +
        '<div class="aside__hr"></div><dl class="rows">' +
        rows.map(function (r) {
          return '<div class="row"><dt>' + r[0] + "</dt><dd" + (r[1] ? "" : ' class="empty"') + ">" +
                 esc(r[1] || "—") + "</dd></div>";
        }).join("") + "</dl></div>";
    }

    function render() {
      purge();
      if (step > maxSeen) maxSeen = step;
      renderSteps();
      var st = SCHEMA[step], last = step === SCHEMA.length - 1;

      var body = '<div class="grp"><div class="grp__head"><div class="grp__ico">' + st.icon + "</div>" +
        '<h2 class="grp__t">' + st.title + "</h2></div>" +
        (st.hint ? '<p class="grp__hint">' + st.hint + "</p>" : "") +
        st.fields.filter(visible).map(fieldHTML).join("") +
        '<div class="cdc-hp"><label>Ne pas remplir<input type="text" data-hp tabindex="-1" autocomplete="off"></label></div></div>';

      if (step === 0 && gate === "fichier_modif")
        body += '<div class="note"><span>🧊</span><span>Vous disposez d\'un fichier 3D à modifier : pensez à le joindre à la dernière étape.</span></div>';
      if (step === 1 && (has("c_milieu", "exterieur") || has("c_milieu", "chaud")))
        body += '<div class="note"><span>🧪</span><span>Environnement exigeant relevé : le choix du matériau sera déterminant (ASA, PETG ou polymère technique). Nous le justifierons dans la proposition.</span></div>';
      if (step === 3 && S.f_texture && S.f_texture.length && !has("f_texture", "aucune") && S.f_faces === "toutes")
        body += '<div class="note note--warn"><span>⚠️</span><span><b>Texture et faces visibles sont incompatibles en l\'état.</b><br>' +
                "La texture ne se transfère que sur la face posée sur le plateau. Si toutes les faces sont visibles, " +
                "elle n'apparaîtra que sur l'une d'elles : indiquez-nous laquelle doit la porter.</span></div>";
      if (step === 3 && (has("f_effet", "carbone") || has("f_effet", "metal")))
        body += '<div class="note"><span>⚙️</span><span>Les filaments chargés (carbone, métal) sont plus rigides mais plus cassants et plus abrasifs. Nous vous dirons si l\'effet est compatible avec l\'usage décrit.</span></div>';
      if (step === 4 && S.b_budget === "-50")
        body += '<div class="note note--warn"><span>⚠️</span><span><b>Un projet complet démarre rarement sous 50 €.</b><br>Ce montant couvre généralement l\'impression d\'un fichier déjà prêt. Si c\'est votre cas, le <a href="' +
                esc(CFG.url_devis) + '">devis d\'impression</a> est plus adapté. Sinon, poursuivez : nous proposerons la version la plus accessible du projet.</span></div>';
      if (step === 4 && S.b_budget === "cadrer")
        body += '<div class="note"><span>💡</span><span>Sans fourchette, nous construirons la proposition en trois niveaux (essentiel, recommandé, complet) pour que vous puissiez arbitrer.</span></div>';
      if (step === 5 && FILES.length > 0)
        body += '<div class="note"><span>📸</span><span><b>Pour que vos photos soient exploitables :</b> posez l\'objet sur un fond uni et contrasté, photographiez-le de face, de dessus et de côté à hauteur d\'objet, et placez une règle ou une pièce de monnaie dans le cadre. Une photo prise en biais, sans repère de taille, ne permet de retrouver aucune dimension.</span></div>';

      var nav = '<div class="nav">' +
        (step > 0 ? '<button type="button" class="btn btn--s" data-prev>Étape précédente</button>' : "<span></span>") +
        '<button type="button" class="btn btn--p" data-next' + (stepValid(step) ? "" : " disabled") + ">" +
        (last ? "Générer mon cahier des charges" : "Continuer") + "</button></div>";

      q("[data-cdc-app]").innerHTML =
        '<div class="cdc__grid"><div><div class="cdc__panel">' + body + "</div>" + nav + "</div>" + asideHTML() + "</div>";

      bind();
      var p = q("[data-prev]");
      if (p) p.onclick = function () { step--; save(); render(); top(); };
      q("[data-next]").onclick = function () {
        if (last) renderDoc(); else { step++; save(); render(); }
        top();
      };
    }

    /* ---------- Liaisons ---------- */
    var addrTimer = null;

    function bind() {
      each("[data-sw]", function (b) {
        b.onclick = function () {
          var id = b.getAttribute("data-sw"), v = b.getAttribute("data-v"), arr = S[id] || [];
          if (arr.indexOf(v) > -1) arr = arr.filter(function (x) { return x !== v; });
          else arr = (v === "conseil") ? ["conseil"] : arr.filter(function (x) { return x !== "conseil"; }).concat([v]);
          S[id] = arr; save(); render();
        };
      });
      each("[data-qset]", function (b) {
        b.onclick = function () { S.v_qte = b.getAttribute("data-qset"); save(); render(); };
      });
      each("[data-qstep]", function (b) {
        b.onclick = function () {
          var n = (parseInt(S.v_qte, 10) || 1) + parseInt(b.getAttribute("data-qstep"), 10);
          S.v_qte = String(Math.max(1, n)); save(); render();
        };
      });

      each("[data-cdc-app] input, [data-cdc-app] textarea, [data-cdc-app] select", function (el) {
        if (el.hasAttribute("data-hp")) return;
        if (el.dataset.inline) {
          el.addEventListener("change", function () { S[el.dataset.inline] = el.checked; save(); render(); });
          return;
        }
        if (el.type === "file") return;
        var ev = (el.type === "radio" || el.type === "checkbox" || el.tagName === "SELECT") ? "change" : "input";
        el.addEventListener(ev, function () {
          var n = el.name;
          if (el.type === "radio") { S[n] = el.value; save(); render(); return; }
          if (el.type === "checkbox") {
            var arr = S[n] || [];
            if (el.checked) {
              arr = (el.value === "aucun" || el.value === "aucune")
                ? [el.value]
                : arr.filter(function (v) { return v !== "aucun" && v !== "aucune"; }).concat([el.value]);
            } else arr = arr.filter(function (v) { return v !== el.value; });
            S[n] = arr; save(); render(); return;
          }
          if (el.dataset.dim) { S[n] = S[n] || {}; S[n][el.dataset.dim] = el.value; }
          else S[n] = el.value;
          if (el.hasAttribute("data-addr")) {
            clearTimeout(addrTimer); addrTimer = setTimeout(function () { lookupAddr(el.value); }, 300);
          }
          save(); refreshAside();
          var nx = q("[data-next]"); if (nx) nx.disabled = !stepValid(step);
        });
        if (el.type === "email") {
          el.addEventListener("blur", function () {
            el.classList.toggle("is-error", !!el.value && !validEmail(el.value));
          });
        }
      });

      var drop = q("[data-drop]"), fi = q("[data-file]");
      if (drop && fi) {
        drop.onclick = function () { fi.click(); };
        drop.addEventListener("dragover", function (e) { e.preventDefault(); drop.classList.add("is-over"); });
        drop.addEventListener("dragleave", function () { drop.classList.remove("is-over"); });
        drop.addEventListener("drop", function (e) {
          e.preventDefault(); drop.classList.remove("is-over"); addFiles(e.dataTransfer.files);
        });
        fi.onchange = function () { addFiles(fi.files); };
        each("[data-rm]", function (b) {
          b.onclick = function () { FILES.splice(+b.getAttribute("data-rm"), 1); render(); };
        });
      }
    }
    function refreshAside() { var o = q(".cdc__aside"); if (o) o.outerHTML = asideHTML(); }
    function top() { root.scrollIntoView({ behavior: "smooth", block: "start" }); }

    /* ---------- Autocomplétion adresse (API Adresse — BAN) ---------- */
    function lookupAddr(v) {
      var box = q("[data-addr-sugg]"); if (!box) return;
      if (!v || v.length < 4) { box.innerHTML = ""; return; }
      fetch("https://api-adresse.data.gouv.fr/search/?limit=5&autocomplete=1&q=" + encodeURIComponent(v))
        .then(function (r) { return r.json(); })
        .then(function (d) {
          var list = (d.features || []).map(function (ft) {
            var p = ft.properties;
            return { label: p.label, cp: p.postcode, ville: p.city, voie: p.name };
          });
          if (!list.length) { box.innerHTML = ""; return; }
          box.innerHTML = '<div class="sugg">' + list.map(function (a, i) {
            return '<button type="button" data-a="' + i + '">' + esc(a.label) + "</button>";
          }).join("") + '<div class="src">Base Adresse Nationale</div></div>';
          var btns = box.querySelectorAll("[data-a]");
          for (var i = 0; i < btns.length; i++) {
            (function (b) {
              b.onclick = function () {
                var a = list[+b.getAttribute("data-a")];
                S.ct_adresse = a.voie; S.ct_cp = a.cp; S.ct_ville = a.ville;
                setVal("ct_adresse", a.voie); setVal("ct_cp", a.cp); setVal("ct_ville", a.ville);
                box.innerHTML = ""; save(); refreshAside();
                var nx = q("[data-next]"); if (nx) nx.disabled = !stepValid(step);
              };
            })(btns[i]);
          }
        })
        .catch(function () { box.innerHTML = ""; });
    }
    function setVal(name, v) { var i = q('[name="' + name + '"]'); if (i) i.value = v; }

    /* ---------- Fichiers : redimensionnement puis encodage en mémoire ---------- */
    var MAX_TOTAL = 25 * 1024 * 1024;
    function addFiles(list) {
      var arr = Array.prototype.slice.call(list || []);
      arr.forEach(function (file) {
        var total = FILES.reduce(function (s, o) { return s + (o.size || 0); }, 0);
        if (total + file.size > MAX_TOTAL) { alert("Limite de 25 Mo atteinte : ce fichier n'a pas été ajouté."); return; }
        var entry = { name: file.name, size: file.size, status: "up", data: null, type: null };
        FILES.push(entry);
        prepare(file).then(function (blob) { return encode(entry, blob); })
          .catch(function () { entry.status = "ko"; render(); });
      });
      render();
    }
    /* Les photos de téléphone (dont HEIC) sont converties en JPEG et
       redimensionnées : format lisible par le générateur de PDF, poids divisé par 5 à 10. */
    function prepare(file) {
      return new Promise(function (res) {
        if (!/^image\//.test(file.type) && !/\.heic$/i.test(file.name)) return res(file);
        var img = new Image(), url = URL.createObjectURL(file);
        img.onload = function () {
          var max = 1600, w = img.width, h = img.height;
          var sc = Math.min(1, max / Math.max(w, h));
          var cv = document.createElement("canvas");
          cv.width = Math.round(w * sc); cv.height = Math.round(h * sc);
          cv.getContext("2d").drawImage(img, 0, 0, cv.width, cv.height);
          cv.toBlob(function (b) { URL.revokeObjectURL(url); res(b || file); }, "image/jpeg", 0.82);
        };
        img.onerror = function () { URL.revokeObjectURL(url); res(file); };
        img.src = url;
      });
    }
    /* Sans stockage externe : le fichier est encodé et conservé en mémoire
       jusqu'à l'envoi du formulaire. */
    function encode(entry, blob) {
      return new Promise(function (res, rej) {
        var fr = new FileReader();
        fr.onload = function () {
          entry.data = String(fr.result).split(",")[1];
          entry.type = blob.type || "application/octet-stream";
          entry.size = blob.size;
          entry.status = "ok";
          render(); res();
        };
        fr.onerror = function () { entry.status = "ko"; render(); rej(); };
        fr.readAsDataURL(blob);
      });
    }

    /* ---------- Récapitulatif ---------- */
    function missHTML() {
      var m = manquants();
      if (!m.length)
        return '<div class="miss miss__ok"><h4>Dossier complet</h4>' +
               "<p>Toutes les informations utiles à l'analyse sont renseignées. Nous pouvons chiffrer sans revenir vers vous.</p></div>";
      return '<div class="miss"><h4>' + m.length + " point" + (m.length > 1 ? "s" : "") + " à compléter</h4>" +
        "<p>Ces informations ne sont pas obligatoires, mais leur absence a une conséquence directe sur la proposition. " +
        "Vous pouvez envoyer le document tel quel : nous reviendrons vers vous sur ces points.</p><ul>" +
        m.map(function (x) {
          return '<li><span class="i">›</span><span><b>' + esc(x.l) + "</b><em>" + esc(x.i) + "</em>" +
                 '<button type="button" data-goto="' + x.s + '">Compléter</button></span></li>';
        }).join("") + "</ul></div>";
    }

    function renderDoc() {
      q("[data-cdc-steps]").hidden = true;
      REF = REF || "CDC-" + new Date().getFullYear() + "-" + (Math.floor(Math.random() * 9000) + 1000);
      var cx = complexity();
      var gateLbl = { idee: "Idée à concevoir", objet: "Objet existant à reproduire ou améliorer",
        plan: "Croquis ou plans fournis", fichier_modif: "Fichier 3D existant à modifier" }[gate] || "—";

      var secs = SCHEMA.map(function (st) {
        var lines = st.fields.filter(function (f) { return visible(f) && answered(f); }).map(function (f) {
          var v = S[f.id], out;
          if (f.type === "files") out = FILES.length + " fichier" + (FILES.length > 1 ? "s" : "") + " — annexés au PDF";
          else if (f.type === "mesure") out = S[f.a.id] + " = " + S[f.b.id] + " " + (S[f.u.id] || "mm");
          else if (f.type === "duo") out = S[f.a.id] + " " + S[f.b.id];
          else if (f.type === "multi" || f.type === "swatch") out = v.map(function (x) { return labelOf(f, x); }).join(", ");
          else if (f.type === "dims") out = (v.x || "?") + " × " + (v.y || "?") + " × " + (v.z || "?") + " mm";
          else if (f.type === "choice") out = labelOf(f, v);
          else out = v;
          return '<div class="doc__line"><dt>' + esc(f.l) + "</dt><dd>" + esc(out) + "</dd></div>";
        }).join("");
        if (st.key === "contraintes" && S.c_dims_nc)
          lines += '<div class="doc__line"><dt>Encombrement maximal (mm)</dt><dd>À définir ensemble</dd></div>';
        return lines ? '<div class="doc__sec"><h4>' + st.title + "</h4><dl>" + lines + "</dl></div>" : "";
      }).join("");

      var bloc = PAYANT
        ? '<div class="pay"><h4>' + esc(CFG.etude_titre) + "</h4>" +
          "<p>" + CFG.etude_texte + "</p>" +
          '<div class="price">' + esc(CFG.etude_prix) + "<small> " + esc(CFG.etude_mention) + "</small></div>" +
          '<label class="inline" style="margin:14px 0 16px"><input type="checkbox" data-ok>' +
          '<span style="font-size:13px">' + esc(CFG.etude_renonciation) + "</span></label>" +
          '<button type="button" class="btn btn--p btn--w" data-pay disabled>Payer ' + esc(CFG.etude_prix) + " et lancer l'étude</button>" +
          '<button type="button" class="btn btn--s btn--w" data-only style="margin-top:8px">Recevoir seulement mon cahier des charges</button>' +
          '<p data-err style="color:var(--cdc-error);font-size:13px;margin:12px 0 0"></p></div>'
        : '<div class="pay"><h4>' + esc(CFG.envoi_titre) + "</h4>" +
          "<p>" + CFG.envoi_texte + "</p>" +
          '<button type="button" class="btn btn--p btn--w" data-only>Envoyer mon cahier des charges</button>' +
          '<p data-err style="color:var(--cdc-error);font-size:13px;margin:12px 0 0"></p></div>';

      var legal = CFG.cgv_texte
        ? '<div class="legal">' + CFG.cgv_texte +
          (CFG.cgv_lien ? ' <a href="' + esc(CFG.cgv_lien) + '" target="_blank" rel="noopener">Conditions générales de vente</a>.' : "") +
          "</div>"
        : "";

      q("[data-cdc-app]").innerHTML =
        '<div class="cdc__grid"><div><div class="doc">' +
        '<div class="doc__ref">' + REF + " · " + new Date().toLocaleDateString("fr-FR") + "</div>" +
        '<h2 class="doc__t">' + esc(S.p_nom || "Projet sur mesure") + "</h2>" +
        '<div class="doc__sec"><h4>Synthèse</h4><dl>' +
        '<div class="doc__line"><dt>Point de départ</dt><dd>' + gateLbl + "</dd></div>" +
        '<div class="doc__line"><dt>Complexité estimée</dt><dd>' + cx.t + " (indice " + cx.n + ")</dd></div>" +
        '<div class="doc__line"><dt>Complétude du document</dt><dd>' + progress() + " %</dd></div></dl></div>" +
        secs + legal + "</div>" +
        missHTML() + bloc +
        '<div class="nav"><button type="button" class="btn btn--s" data-edit>Modifier mes réponses</button><span></span></div></div>' +
        '<div class="cdc__aside"><div class="aside__tag">✅ Document prêt</div>' +
        '<p style="font-size:14px;line-height:1.6;color:var(--cdc-text-muted);margin:0 0 18px">Référence ' + REF +
        ". Ce document sert de base à notre proposition : relisez-le avant envoi.</p>" +
        '<div class="aside__hr"></div><div class="aside__lbl">Suite du parcours</div><dl class="rows">' +
        '<div class="row"><dt>PDF par email</dt><dd>Immédiat</dd></div>' +
        '<div class="row"><dt>Analyse technique</dt><dd>48 h ouvrées</dd></div>' +
        '<div class="row"><dt>Proposition chiffrée</dt><dd>Incluse</dd></div>' +
        (PAYANT ? '<div class="row"><dt>Frais d\'étude</dt><dd>Déduits</dd></div>' : "") +
        "</dl></div></div>";

      each("[data-goto]", function (b) {
        b.onclick = function () { step = +b.getAttribute("data-goto"); render(); top(); };
      });
      q("[data-edit]").onclick = function () { step = SCHEMA.length - 1; render(); top(); };
      var ok = q("[data-ok]");
      if (ok) ok.onchange = function () { q("[data-pay]").disabled = !this.checked; };
      var pay = q("[data-pay]");
      if (pay) pay.onclick = function () { submit(true, this); };
      q("[data-only]").onclick = function () { submit(false, this); };
    }

    /* ---------- Envoi ---------- */
    function submit(paid, btn) {
      var hp = q("[data-hp]");
      if ((hp && hp.value) || Date.now() - T0 < 8000) { return; } // robot probable : ignoré silencieusement
      var err = q("[data-err]"); if (err) err.textContent = "";
      btn.classList.add("is-busy");
      var payload = {
        ref: REF, gate: gate, paid: !!paid,
        answers: S,
        files: FILES.filter(function (f) { return f.status === "ok"; })
                    .map(function (f) { return { name: f.name, data: f.data, type: f.type, size: f.size }; }),
        manquants: manquants().map(function (x) { return { l: x.l, i: x.i }; }),
        complexite: complexity(), completude: progress(),
        page: location.href, ts: new Date().toISOString()
      };
      fetch(CFG.endpoint + "/cdc", {
        method: "POST", headers: { "Content-Type": "application/json" }, body: JSON.stringify(payload)
      })
        .then(function (r) { if (!r.ok) throw new Error("http " + r.status); return r.json(); })
        .then(function (d) {
          if (d && d.ref) REF = d.ref;
          clearSaved();
          if (paid) return addToCart();
          renderDone();
        })
        .catch(function () {
          btn.classList.remove("is-busy");
          if (err) err.textContent = "L'envoi a échoué. Réessayez, ou écrivez-nous à " + CFG.email_contact +
            " en indiquant la référence " + REF + ".";
        });
    }

    function addToCart() {
      return fetch("/cart/add.js", {
        method: "POST", headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ items: [{
          id: Number(CFG.etude_variant_id), quantity: 1,
          properties: { "Dossier": REF, "Projet": S.p_nom || "", "Complexité": complexity().t }
        }] })
      }).then(function (r) {
        if (!r.ok) throw new Error("cart");
        window.location.href = "/checkout";
      }).catch(function () { renderDone(true); });
    }

    function renderDone(cartFailed) {
      q("[data-cdc-steps]").hidden = true;
      q("[data-cdc-app]").innerHTML =
        '<div class="done"><h2>Votre cahier des charges est envoyé</h2>' +
        "<p>Référence <strong>" + REF + "</strong>. Vous le recevez à l'instant par email au format PDF, " +
        "avec vos documents en annexe.</p>" +
        (cartFailed
          ? "<p>Le règlement des frais d'étude n'a pas pu être ouvert. Écrivez-nous à " + esc(CFG.email_contact) +
            " en indiquant votre référence, nous vous transmettrons un lien de paiement.</p>"
          : PAYANT
            ? "<p>L'analyse technique démarre au règlement des frais d'étude. Sans règlement, votre document reste " +
              "à votre disposition et vous pouvez revenir vers nous quand vous le souhaitez.</p>"
            : "<p>Nous analysons votre demande et revenons vers vous sous 48 h ouvrées avec une proposition chiffrée.</p>") +
        '<a class="btn btn--s" href="/" style="margin-top:18px">Retour à la boutique</a></div>';
      top();
    }

    renderGate();
  }
})();